import { useSignUpQueryParams } from "@faire/retailer-visitor-shared/views/SignUp/_hooks/useSignUpQueryParams";
import { getPreSignUpActivities } from "@faire/retailer-visitor-shared/views/SignUp/_utils/getPreSignUpActivities";
import { useSignUpRequest } from "@faire/retailer-visitor-shared/views/SignUp/SignUpRequestContext";
import { usePrefetchQuery_escape_hatch as useVerticalizedImagePrefetchQuery } from "@faire/web-api--source/endpoints/www/api/retailer/sign-up-verticalized-image/post-hooks";
import { IMatchedBusiness } from "@faire/web-api--source/indigofair/data/IMatchedBusiness";
import { ISignUpVerticalizedImageRequest } from "@faire/web-api--source/indigofair/data/ISignUpVerticalizedImageRequest";
import { IStyleQuiz } from "@faire/web-api--source/indigofair/data/IStyleQuiz";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
import { useCallback } from "react";

export const useVerticalizedImagePrefetch = () => {
  const [
    { matched_business, user, website_url, country, postal_code, style_quiz },
  ] = useSignUpRequest([
    "matched_business",
    "user",
    "website_url",
    "country",
    "postal_code",
    "style_quiz",
  ]);
  const { queryParams } = useSignUpQueryParams();
  const prefetch = useVerticalizedImagePrefetchQuery();

  return useCallback(
    (storeType: {
      matchedBusiness?: IMatchedBusiness;
      styleQuiz?: IStyleQuiz;
    }) => {
      prefetch(
        ISignUpVerticalizedImageRequest.build({
          matched_business: storeType.matchedBusiness ?? matched_business,
          email_address: user?.email_address,
          retailer_store_name: matched_business?.name,
          website_url,
          country: country as keyof typeof ISO3166Alpha3,
          postal_code,
          style_quiz: storeType.styleQuiz ?? style_quiz,
          pre_sign_up_activities: getPreSignUpActivities(queryParams.source),
        })
      );
    },
    [
      prefetch,
      matched_business,
      user,
      website_url,
      country,
      postal_code,
      style_quiz,
      queryParams.source,
    ]
  );
};
